<script lang="ts">
	import { onMount } from "svelte";
	import { Route, Router } from "svelte-routing";
	import OverlaySpinner from "../src/components/OverlaySpinner/OverlaySpinner.svelte";
	import { loadSpinner } from "../src/store/store";
	import { applyBrand } from "./brand";
	import Layout from "./containers/Layout.svelte";
	import ForgotPassword from "./views/ForgotPassword.svelte";
	import Login from "./views/Login.svelte";
	import NotFound from "./views/NotFound.svelte";
	import ResetPassword from "./views/ResetPassword.svelte";
	export let url = "";

	onMount(() => {
		applyBrand();
	});
</script>

<Router {url}>
	<div>
		<Route path="/login" component={Login} />
		<Route path="/reset-password/*" component={ResetPassword} />
		<Route path="/forgot-password/*" component={ForgotPassword} />
		<Route path="/not-found" component={NotFound} />
		<Route path="/*" component={Layout} />
	</div>
</Router>

{#if $loadSpinner}
	<OverlaySpinner />
{/if}
